import {Component, Input, OnInit} from '@angular/core';
import {GO_CATEGORIES} from "../../enums/e-game-objects";
import {IDocument} from "../../interfaces/document.definition";
import {WatchService} from "../../services/watch.service";

@Component({
  selector: 'nv-categories-list',
  templateUrl: './nv-categories-list.component.html',
  styles: []
})
export class NvCategoriesListComponent implements OnInit {

  @Input() showAddButton = true;
  @Input() showRemoveButton = true;
  @Input() document:IDocument;
  @Input() prop: string;
  _label: string;
  @Input() set label(v: string) {
    this._label = v;
  }

  get label(): string {
    return this._label || this.prop;
  }

  categories:string[] = [GO_CATEGORIES.STUFF, GO_CATEGORIES.COMMON_BUILDING, GO_CATEGORIES.HOUSE, GO_CATEGORIES.DECOR, GO_CATEGORIES.PLANT, GO_CATEGORIES.ANIMAL];
  currentCat:string;

  constructor(private watchService:WatchService) { }

  ngOnInit() {
  }

  addItem(){
    if (typeof this.document[this.prop] === "undefined") {
      this.document[this.prop] = []; // todo watch service!
    }
    this.document[this.prop].push(this.currentCat);
    this.watchService.notify();
  }

  removeItem(index: number) {
    let c = this.document[this.prop];
    c.splice(index, 1);
    this.watchService.notify();
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-categories-list/nv-categories-list.component.ts